/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */


import { Component, Input, ElementRef, Renderer, ViewEncapsulation, HostBinding } from '@angular/core';
import classNames from 'classnames';
/**
 * 24 栅格系统 之 Row
 * 布局的栅格化系统，我们是基于行（row）和列（col）来定义信息区块的外部框架，以保证页面的每个区域能够稳健地排布起来。下面简单介绍一下它的工作原理：
 * 
 * - 通过`row`在水平方向建立一组`column`（简写col）
 * - 你的内容应当放置于`col`内，并且，只有`col`可以作为`row`的直接元素
 * - 栅格系统中的列是指1到24的值来表示其跨越的范围。例如，三个等宽的列可以使用`.col-8`来创建
 * - 如果一个`row`中的`col`总和超过 24，那么多余的`col`会作为一个整体另起一行排列
 */
export class Row {
/**
 * 样式前缀
 */
prefixCls = 'ant-row';

    /*
     * 布局模式，可选 flex，现代浏览器 下有效。默认为空。
     */
     type: 'flex' = null;
/**
 * flex 布局下的垂直对齐方式：top middle bottom
 */
align?: 'top' | 'middle' | 'bottom' = 'top';
/**
 * flex 布局下的水平排列方式：start end center space-around space-between
 */
justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between' = 'start';
/**
 * 栅格间隔。默认为0。
 */
gutter = 0;
/**
 * 用户CSS样式
 */
class: string;
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(private _renderer: Renderer,
private _elementRef: ElementRef) {

    }
/**
 * The underlying host native element
 * @return {?}
 */
getHostElement(): HTMLElement {
        return /** @type {?} */(( this._elementRef.nativeElement as HTMLElement));
    }
/**
 * 最终样式
 * @return {?}
 */
get classes(): string {
        return this.getClasses();
    }
/**
 * @return {?}
 */
getClasses(): string {
        return classNames({
            [`${this.prefixCls}`]: !this.type,
            [`${this.prefixCls}-${this.type}`]: this.type,
            [`${this.prefixCls}-${this.type}-${this.justify}`]: this.type && this.justify,
            [`${this.prefixCls}-${this.type}-${this.align}`]: this.type && this.align,
        }, this.class);
    }
/**
 * 特殊样式
 * @return {?}
 */
get marginLeft(): any {
        return (this.gutter > 0) ? (this.gutter / -2) + 'px' : null;
    }
/**
 * 特殊样式
 * @return {?}
 */
get marginRight(): any {
        return (this.gutter > 0) ? (this.gutter / -2) + 'px' : null;
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-row',
    template: `
        <ng-content></ng-content>
    `,
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'type': [{ type: Input },],
'align': [{ type: Input },],
'justify': [{ type: Input },],
'gutter': [{ type: Input },],
'class': [{ type: Input },],
'classes': [{ type: HostBinding, args: ['class', ] },],
'marginLeft': [{ type: HostBinding, args: ['style.margin-left', ] },],
'marginRight': [{ type: HostBinding, args: ['style.margin-right', ] },],
};
}

function Row_tsickle_Closure_declarations() {
/** @type {?} */
Row.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Row.ctorParameters;
/** @type {?} */
Row.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Row.prototype.prefixCls;
/** @type {?} */
Row.prototype.type;
/**
 * flex 布局下的垂直对齐方式：top middle bottom
 * @type {?}
 */
Row.prototype.align;
/**
 * flex 布局下的水平排列方式：start end center space-around space-between
 * @type {?}
 */
Row.prototype.justify;
/**
 * 栅格间隔。默认为0。
 * @type {?}
 */
Row.prototype.gutter;
/**
 * 用户CSS样式
 * @type {?}
 */
Row.prototype.class;
/** @type {?} */
Row.prototype._renderer;
/** @type {?} */
Row.prototype._elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
